import DOMPurify from 'dompurify'

export default DOMPurify
